import React from 'react';
import { useNavigate } from 'react-router-dom';
import colors, { fonts, shadows } from '../theme';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      fontFamily: fonts.landing,
      background: colors.landing.bg,
      minHeight: '100vh',
      color: colors.landing.text,
    }}>
      <style>{`
        .gradient-text {
          background: ${colors.gradients.coral};
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

      {/* Header/Nav */}
      <nav style={{
        padding: '24px 48px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${colors.overlay.coralBorder}`,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/')}>
          <img
            src="/logo192.png"
            alt="Miblio"
            style={{
              width: '40px',
              height: '40px',
            }}
          />
          <span style={{
            fontSize: '24px',
            fontWeight: 800,
          }} className="gradient-text">
            miblio
          </span>
        </div>
        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
          <button onClick={() => navigate('/login')} style={{
            background: 'transparent',
            border: 'none',
            color: colors.landing.text,
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 600,
          }}>
            Sign In
          </button>
          <button onClick={() => navigate('/register')} style={{
            background: colors.gradients.coral,
            border: 'none',
            color: colors.white,
            padding: '12px 32px',
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 700,
            boxShadow: shadows.coralMd,
          }}>
            Get Started
          </button>
        </div>
      </nav>

      {/* Content */}
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '80px 48px',
      }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: 800,
          marginBottom: '16px',
          background: colors.gradients.coral,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          Terms of Service
        </h1>

        <p style={{
          fontSize: '14px',
          color: colors.gray[600],
          marginBottom: '48px',
        }}>
          Last Updated: December 29, 2024
        </p>

        <div style={{
          fontSize: '16px',
          lineHeight: 1.8,
          color: colors.landing.text,
        }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              1. Acceptance of Terms
            </h2>
            <p style={{ marginBottom: '16px' }}>
              These Terms of Service ("Terms") govern your access to and use of Miblio's knowledge sharing and learning platform ("Service"). By accessing or using our Service, you agree to be bound by these Terms.
            </p>
            <p>
              If you do not agree to these Terms, you may not access or use the Service.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              2. Eligibility
            </h2>
            <p>
              You must be at least 13 years old to use Miblio. By using the Service, you represent and warrant that you meet this age requirement and have the legal capacity to enter into these Terms.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              3. Account Registration
            </h2>
            <p style={{ marginBottom: '12px' }}>To use Miblio, you must create an account:</p>
            <ul style={{ paddingLeft: '24px' }}>
              <li>You must provide accurate, complete, and current information</li>
              <li>You are responsible for maintaining the confidentiality of your password</li>
              <li>You are responsible for all activities that occur under your account</li>
              <li>You must notify us immediately of any unauthorized use of your account</li>
              <li>One account per organization administrator; additional users must be invited</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              4. Subscription Plans and Billing
            </h2>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              4.1 Plans
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Miblio offers various subscription plans (Free, Starter, Professional, Enterprise). Plan features, pricing, and limitations are described on our website and may change with notice.
            </p>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              4.2 Billing
            </h3>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li>Paid plans are billed monthly or annually in advance</li>
              <li>All fees are in U.S. Dollars and non-refundable except as required by law</li>
              <li>You authorize us to charge your payment method on a recurring basis</li>
              <li>Failure to pay may result in service suspension or termination</li>
              <li>We may change pricing with 30 days' notice to existing subscribers</li>
            </ul>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              4.3 Cancellation and Refunds
            </h3>
            <ul style={{ paddingLeft: '24px' }}>
              <li>You may cancel your subscription at any time from your account settings</li>
              <li>Cancellation takes effect at the end of your current billing period</li>
              <li>No refunds for partial months or unused portions of your subscription</li>
              <li>Upon cancellation, you lose access to all premium features</li>
              <li>Your data will be retained for 30 days after cancellation, then deleted</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              5. Acceptable Use Policy
            </h2>
            <p style={{ marginBottom: '12px' }}>You agree NOT to:</p>
            <ul style={{ paddingLeft: '24px' }}>
              <li>Violate any laws or regulations</li>
              <li>Infringe on intellectual property rights of others</li>
              <li>Upload malicious code, viruses, or harmful content</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Reverse engineer, decompile, or disassemble the Service</li>
              <li>Use the Service to harass, abuse, or harm others</li>
              <li>Scrape, spider, or use automated tools without permission</li>
              <li>Resell or redistribute the Service without authorization</li>
              <li>Share your account credentials with unauthorized users</li>
              <li>Upload content containing personal data of others without consent</li>
            </ul>
            <p style={{ marginTop: '16px' }}>
              Violation of this policy may result in immediate termination of your account.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              6. User Content
            </h2>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              6.1 Your Content
            </h3>
            <p style={{ marginBottom: '16px' }}>
              You retain all rights to content you create or upload to Miblio ("User Content"). By uploading User Content, you grant us a worldwide, non-exclusive, royalty-free license to use, store, and display your content solely to provide and improve the Service.
            </p>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              6.2 AI-Generated Content
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Quiz questions generated by our AI from your content are owned by you. We may use anonymized, aggregated data from AI interactions to improve our services.
            </p>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              6.3 Integrated Content
            </h3>
            <p>
              Content accessed through integrations (Notion, Google Docs, Confluence) remains subject to the terms of those third-party services. We fetch this content on your behalf but do not permanently store it.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              7. Intellectual Property
            </h2>
            <p style={{ marginBottom: '12px' }}>
              The Service, including its software, design, text, graphics, and other content (excluding User Content), is owned by Miblio and protected by copyright, trademark, and other intellectual property laws.
            </p>
            <p>
              You may not copy, modify, distribute, sell, or lease any part of our Service without our express written permission.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              8. Third-Party Integrations
            </h2>
            <p style={{ marginBottom: '12px' }}>
              Miblio integrates with third-party services (Notion, OpenAI, etc.). Your use of these integrations is subject to:
            </p>
            <ul style={{ paddingLeft: '24px' }}>
              <li>The third party's own terms of service and privacy policies</li>
              <li>Your responsibility to maintain valid credentials and permissions</li>
              <li>Our right to discontinue integrations at any time</li>
            </ul>
            <p style={{ marginTop: '16px' }}>
              We are not responsible for changes, interruptions, or failures of third-party services.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              9. Service Availability
            </h2>
            <p>
              We strive to provide reliable service but do not guarantee uninterrupted access. We may modify, suspend, or discontinue the Service (or any part) at any time with or without notice. We are not liable for any modification, suspension, or discontinuation.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              10. Data Backup and Loss
            </h2>
            <p>
              While we perform regular backups, you are responsible for maintaining your own backups of critical data. We are not liable for any data loss or corruption, regardless of cause.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              11. Disclaimers
            </h2>
            <p style={{ marginBottom: '12px', fontWeight: 600 }}>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING:
            </p>
            <ul style={{ paddingLeft: '24px' }}>
              <li>No warranty of merchantability or fitness for a particular purpose</li>
              <li>No warranty that the Service will be error-free or uninterrupted</li>
              <li>No warranty regarding the accuracy or reliability of AI-generated content</li>
              <li>No warranty that defects will be corrected</li>
            </ul>
            <p style={{ marginTop: '16px' }}>
              You use the Service at your own risk.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              12. Limitation of Liability
            </h2>
            <p style={{ marginBottom: '12px', fontWeight: 600 }}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, MIBLIO SHALL NOT BE LIABLE FOR:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li>Indirect, incidental, special, consequential, or punitive damages</li>
              <li>Loss of profits, revenue, data, or business opportunities</li>
              <li>Service interruptions or data loss</li>
              <li>Unauthorized access to your account or data</li>
              <li>Actions of third-party integrations or services</li>
            </ul>
            <p>
              <strong>IN NO EVENT SHALL OUR TOTAL LIABILITY EXCEED THE AMOUNT YOU PAID US IN THE 12 MONTHS PRECEDING THE CLAIM, OR $100, WHICHEVER IS GREATER.</strong>
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              13. Indemnification
            </h2>
            <p>
              You agree to indemnify, defend, and hold harmless Miblio and its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including legal fees) arising from:
            </p>
            <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
              <li>Your use of the Service</li>
              <li>Your User Content</li>
              <li>Your violation of these Terms</li>
              <li>Your violation of any rights of another party</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              14. Termination
            </h2>
            <p style={{ marginBottom: '12px' }}>
              We may terminate or suspend your account immediately, without notice, for:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li>Violation of these Terms</li>
              <li>Non-payment of fees</li>
              <li>Fraudulent or illegal activity</li>
              <li>At our discretion, with or without cause</li>
            </ul>
            <p>
              Upon termination, your right to use the Service ceases immediately. Sections that by their nature should survive (Intellectual Property, Disclaimers, Limitation of Liability, etc.) will survive termination.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              15. Dispute Resolution
            </h2>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              15.1 Informal Resolution
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Before filing a claim, you agree to contact us at <a href="mailto:support@miblio.io" style={{ color: colors.landing.coral, textDecoration: 'underline' }}>support@miblio.io</a> and attempt to resolve the dispute informally.
            </p>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              15.2 Governing Law
            </h3>
            <p style={{ marginBottom: '16px' }}>
              These Terms are governed by the laws of the State of Delaware, United States, without regard to conflict of law principles.
            </p>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              15.3 Arbitration
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Any disputes that cannot be resolved informally shall be resolved through binding arbitration in accordance with the American Arbitration Association's rules. Arbitration will take place in Delaware or remotely.
            </p>

            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', marginTop: '24px' }}>
              15.4 Class Action Waiver
            </h3>
            <p>
              You agree to resolve disputes with us on an individual basis and waive any right to participate in a class action lawsuit or class-wide arbitration.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              16. Changes to Terms
            </h2>
            <p>
              We may modify these Terms at any time. We will notify you of material changes via email or through the Service. Your continued use after changes constitutes acceptance of the new Terms. If you disagree, you must stop using the Service and cancel your account.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              17. General Provisions
            </h2>
            <ul style={{ paddingLeft: '24px' }}>
              <li><strong>Entire Agreement:</strong> These Terms constitute the entire agreement between you and Miblio</li>
              <li><strong>Severability:</strong> If any provision is found unenforceable, the remaining provisions remain in effect</li>
              <li><strong>No Waiver:</strong> Our failure to enforce any right does not waive that right</li>
              <li><strong>Assignment:</strong> You may not assign these Terms; we may assign them without restriction</li>
              <li><strong>Force Majeure:</strong> We are not liable for failures due to circumstances beyond our control</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '16px', color: colors.landing.coral }}>
              18. Contact Information
            </h2>
            <p style={{ marginBottom: '12px' }}>
              Questions about these Terms? Contact us:
            </p>
            <ul style={{ paddingLeft: '24px' }}>
              <li><strong>Email:</strong> <a href="mailto:legal@miblio.io" style={{ color: colors.landing.coral, textDecoration: 'underline' }}>legal@miblio.io</a></li>
              <li><strong>Support:</strong> <a href="mailto:support@miblio.io" style={{ color: colors.landing.coral, textDecoration: 'underline' }}>support@miblio.io</a></li>
            </ul>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer style={{
        padding: '48px',
        textAlign: 'center',
        background: colors.landing.bg,
        borderTop: `1px solid ${colors.overlay.coralBorder}`,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          marginBottom: '16px',
        }}>
          <img
            src="/logo192.png"
            alt="Miblio"
            style={{
              width: '32px',
              height: '32px',
            }}
          />
          <span style={{
            fontSize: '24px',
            fontWeight: 800,
          }} className="gradient-text">
            miblio
          </span>
        </div>
        <div style={{
          display: 'flex',
          gap: '24px',
          justifyContent: 'center',
          marginBottom: '16px',
        }}>
          <button onClick={() => navigate('/')} style={{
            background: 'transparent',
            border: 'none',
            color: colors.landing.textLight,
            cursor: 'pointer',
            fontSize: '14px',
          }}>
            Home
          </button>
          <button onClick={() => navigate('/security')} style={{
            background: 'transparent',
            border: 'none',
            color: colors.landing.textLight,
            cursor: 'pointer',
            fontSize: '14px',
          }}>
            Security
          </button>
          <button onClick={() => navigate('/privacy')} style={{
            background: 'transparent',
            border: 'none',
            color: colors.landing.textLight,
            cursor: 'pointer',
            fontSize: '14px',
          }}>
            Privacy
          </button>
          <button onClick={() => navigate('/terms')} style={{
            background: 'transparent',
            border: 'none',
            color: colors.landing.textLight,
            cursor: 'pointer',
            fontSize: '14px',
          }}>
            Terms
          </button>
        </div>
        <p style={{
          fontSize: '14px',
          color: colors.landing.textLight,
        }}>
          © 2024 Miblio. Built for teams who learn together.
        </p>
      </footer>
    </div>
  );
}
